module.exports = __webpack_public_path__ + "images/nest-d8e916a0bcebe34dcb6aa43dff3d34b5.jpg";